var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrrPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 72,
    viewBox: "0 0 104 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3250_74241)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 36,
    r: 103,
    fill: "#13C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25 35.7188L45.25 29.2188C44.3438 28.6875 43 29.2188 43 30.5V43.5C43 44.6875 44.25 45.4062 45.25 44.8125L56.25 38.3125C57.2188 37.7188 57.2188 36.3125 56.25 35.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3250_74241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 72,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrrPlay);
export default __webpack_public_path__ + "static/media/crr-play.b9edc7d30545fbda9bffdccfd18dc649.svg";
export { ForwardRef as ReactComponent };